export default {
  layout: {
    rows: [
      {
        fields: [ { name: "visit.name" } ]
      },

      {
        fields: [ { name: "visit.status" } ]
      },

      {
        fields: [ { name: "visit.visitDate" } ]
      },

      {
        fields: [ { name: "visit.site" } ]
      },

      {
        fields: [ { name: "visit.clinicalDiagnoses" } ]
      },

      {
        fields: [ { name: "visit.clinicalStatus" } ]
      },

      {
        fields: [ { name: "visit.cohort" } ]
      },

      {
        fields: [ { name: "visit.surgicalPathologyNumber" } ]
      },

      {
        fields: [ { name: "visit.missedBy" } ]
      },

      {
        fields: [ { name: "visit.missedReason" } ]
      },

      {
        fields: [ { name: "visit.comments" } ]
      }
    ]
  }
}
